// Variant Color Images - Dynamic filtering based on alt tags
// Fix (2025-11-15): Ensure first matching image is selected when a
// pre-selected variant filters images, avoiding the last image showing.
console.log('VariantColorImages: Script loading');

(function() {
  'use strict';
  
  let isInitialized = false;
  
  function initVariantColorImages() {
    if (isInitialized) return;
    
    console.log('VariantColorImages: Initializing...');
    
    // Find product gallery
    const productGallery = document.querySelector('.product-gallery');
    
    if (!productGallery) {
      console.log('VariantColorImages: Product gallery not found');
      return;
    }
    
    // Check if variant color images feature is enabled
    if (!productGallery.hasAttribute('enable-variant-color-images') && !productGallery.hasAttribute('data-enable-variant-color-images')) {
      console.log('VariantColorImages: Feature not enabled');
      return;
    }
    
    console.log('VariantColorImages: Feature enabled, setting up listeners');
    isInitialized = true;
    const filterOption = (productGallery.getAttribute('variant-option-name') || '').toLowerCase().trim(); function restrictToFilterOption(values) { if (!filterOption) return values; const key = Object.keys(values).find(k => k.includes(filterOption)); return key ? { [key]: values[key] } : values; }
    
    // Store original display states
    const originalStates = new Map();

    // Track a pending selection to re-apply after carousel refresh
    let pendingSelection = null;
    
    console.log(`VariantColorImages: Using color and size options for filtering`);
    
    // Add multiple event listeners to catch variant changes
    console.log('VariantColorImages: Setting up event listeners...');
    
    // Listen for variant:change events (this is the main event from the theme)
    document.addEventListener('variant:change', function(event) {
      console.log('VariantColorImages: variant:change event received:', event);
      console.log('VariantColorImages: Event detail:', event.detail);
      handleVariantChange(event.detail);
    });
    
    // Listen for change events on variant picker inputs
    const variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      console.log('VariantColorImages: Found variant picker, adding change listener');
      
      // Listen for changes on option inputs using the correct selector pattern
      const formId = variantPicker.getAttribute('form-id');
      if (formId) {
        const optionSelectors = document.querySelectorAll(`input[data-option-position][form="${formId}"]`);
        console.log(`VariantColorImages: Found ${optionSelectors.length} option selectors for form ${formId}`);
        
        optionSelectors.forEach(selector => {
          selector.addEventListener('change', function() {
            console.log('VariantColorImages: Option selector changed:', selector.name, selector.value, 'position:', selector.getAttribute('data-option-position'));
            // The variant:change event should fire automatically, but we can add a small delay to ensure it's processed
            setTimeout(() => {
              console.log('VariantColorImages: Checking for variant change after option selection');
            }, 50);
          });
        });
      }
    } else {
      console.log('VariantColorImages: No variant picker found');
    }
    
    function handleVariantChange(eventDetail) {
      console.log('VariantColorImages: Handling variant change with detail:', eventDetail);
      
      const variant = eventDetail?.variant;
      if (!variant) {
        console.log('VariantColorImages: No variant data in event');
        resetImageVisibility();
        return;
      }
      
      console.log('VariantColorImages: Variant data:', variant);
      console.log('VariantColorImages: Variant options:', variant.options);
      console.log('VariantColorImages: Variant option1:', variant.option1);
      console.log('VariantColorImages: Variant option2:', variant.option2);
      console.log('VariantColorImages: Variant option3:', variant.option3);
      
      // Get option names and values from the variant picker structure
      const variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) {
        console.log('VariantColorImages: No variant picker found');
        return;
      }
      
      const fieldsets = variantPicker.querySelectorAll('fieldset');
      console.log(`VariantColorImages: Found ${fieldsets.length} fieldsets in variant picker`);
      
      const optionValues = {};
      
      // Get all option values from the variant
      fieldsets.forEach((fieldset, index) => {
        const legend = fieldset.querySelector('legend');
        if (legend) {
          const optionName = legend.textContent.toLowerCase().replace(':', '').trim();
          const optionProperty = `option${index + 1}`;
          const value = variant[optionProperty];
          
          console.log(`VariantColorImages: Fieldset ${index}: legend="${legend.textContent}", optionName="${optionName}", property="${optionProperty}", value="${value}"`);
          
          if (value) {
            optionValues[optionName] = value;
            console.log(`VariantColorImages: Found option "${optionName}" = "${value}"`);
          }
        }
      });
      
      console.log('VariantColorImages: Final option values:', optionValues);
      
      // Update visible images based on all option values
      updateImageVisibility(restrictToFilterOption(optionValues));
    }
    
    function detectCurrentVariant() {
      console.log('VariantColorImages: Manually detecting current variant...');
      
      // Method 1: Try to get current variant from the variant picker's script tag
      const variantPicker = document.querySelector('variant-picker');
      if (variantPicker) {
        const variantScript = variantPicker.querySelector('script[data-variant]');
        if (variantScript) {
          try {
            const variantData = JSON.parse(variantScript.textContent);
            console.log('VariantColorImages: Found variant data from script:', variantData);
            if (variantData) {
              handleVariantChange({ variant: variantData });
              return true;
            }
          } catch (e) {
            console.log('VariantColorImages: Error parsing variant script:', e);
          }
        }
        
        // Method 2: Try to get variant from form data
        const formId = variantPicker.getAttribute('form-id');
        if (formId) {
          const form = document.getElementById(formId);
          if (form) {
            const variantIdInput = form.querySelector('input[name="id"]');
            if (variantIdInput && variantIdInput.value) {
              console.log('VariantColorImages: Found variant ID from form:', variantIdInput.value);
              // Try to find variant data from product JSON
              const productData = getProductData();
              if (productData && productData.variants) {
                const variant = productData.variants.find(v => v.id == variantIdInput.value);
                if (variant) {
                  console.log('VariantColorImages: Found variant from product data:', variant);
                  handleVariantChange({ variant: variant });
                  return true;
                }
              }
            }
          }
        }
        
        // Method 3: Get current selection from checked/selected inputs
        const fieldsets = variantPicker.querySelectorAll('fieldset');
        const optionValues = {};
        let hasSelectedOptions = false;
        
        fieldsets.forEach((fieldset, index) => {
          const legend = fieldset.querySelector('legend');
          if (legend) {
            const optionName = legend.textContent.toLowerCase().replace(':', '').trim();
            
            // Check for selected radio buttons
            const selectedRadio = fieldset.querySelector('input[type="radio"]:checked');
            if (selectedRadio) {
              optionValues[optionName] = selectedRadio.value;
              hasSelectedOptions = true;
              console.log(`VariantColorImages: Found selected radio option "${optionName}": "${selectedRadio.value}"`);
            } else {
              // Check for selected option in select dropdown
              const select = fieldset.querySelector('select');
              if (select && select.value) {
                optionValues[optionName] = select.value;
                hasSelectedOptions = true;
                console.log(`VariantColorImages: Found selected dropdown option "${optionName}": "${select.value}"`);
              }
            }
          }
        });
        
        if (hasSelectedOptions) {
          console.log('VariantColorImages: Using selected options for filtering:', optionValues);
          updateImageVisibility(restrictToFilterOption(optionValues));
          return true;
        }
      }
      
      // Method 4: Try to get from URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const variantParam = urlParams.get('variant');
      if (variantParam) {
        console.log('VariantColorImages: Found variant in URL:', variantParam);
        const productData = getProductData();
        if (productData && productData.variants) {
          const variant = productData.variants.find(v => v.id == variantParam);
          if (variant) {
            console.log('VariantColorImages: Found variant from URL:', variant);
            handleVariantChange({ variant: variant });
            return true;
          }
        }
      }
      
      // Method 5: Check for default/first variant
      const productData = getProductData();
      if (productData && productData.variants && productData.variants.length > 0) {
        const firstVariant = productData.variants[0];
        console.log('VariantColorImages: Using first variant as default:', firstVariant);
        handleVariantChange({ variant: firstVariant });
        return true;
      }
      
      console.log('VariantColorImages: Could not detect current variant, showing all images');
      resetImageVisibility();
      return false;
    }
    
    function getProductData() {
      // Try to get product data from various sources
      
      // Method 1: Look for product JSON in script tags
      const productScripts = document.querySelectorAll('script[type="application/json"]');
      for (const script of productScripts) {
        try {
          const data = JSON.parse(script.textContent);
          if (data && (data.variants || data.product)) {
            console.log('VariantColorImages: Found product data in script tag');
            return data.product || data;
          }
        } catch (e) {
          // Continue to next script
        }
      }
      
      // Method 2: Look for window.product or similar global variables
      if (window.product) {
        console.log('VariantColorImages: Found product data in window.product');
        return window.product;
      }
      
      if (window.productData) {
        console.log('VariantColorImages: Found product data in window.productData');
        return window.productData;
      }
      
      // Method 3: Try to extract from meta tags
      const productMeta = document.querySelector('meta[property="product:variants"]');
      if (productMeta) {
        try {
          const data = JSON.parse(productMeta.content);
          console.log('VariantColorImages: Found product data in meta tag');
          return data;
        } catch (e) {
          // Continue
        }
      }
      
      console.log('VariantColorImages: No product data found');
      return null;
    }
    
    // Try to detect current variant on initialization with multiple attempts
    let initAttempts = 0;
    const maxInitAttempts = 5;
    
    function tryInitialDetection() {
      initAttempts++;
      console.log(`VariantColorImages: Initial detection attempt ${initAttempts}/${maxInitAttempts}`);
      
      const success = detectCurrentVariant();
      
      if (!success && initAttempts < maxInitAttempts) {
        // Retry with increasing delays
        const delay = initAttempts * 200; // 200ms, 400ms, 600ms, 800ms
        console.log(`VariantColorImages: Retrying detection in ${delay}ms`);
        setTimeout(tryInitialDetection, delay);
      } else if (success) {
        console.log('VariantColorImages: Successfully detected initial variant');
      } else {
        console.log('VariantColorImages: Failed to detect initial variant after all attempts');
      }
    }
    
    // Start initial detection
    setTimeout(tryInitialDetection, 100);
    
    function getSelectedOptionValue(variant, optionName) {
      console.log(`VariantColorImages: Getting option value for "${optionName}" from variant:`, variant);
      
      // In Shopify, variants have option1, option2, option3 properties
      // We need to find which option position corresponds to our option name
      const variantPicker = document.querySelector('variant-picker');
      if (variantPicker && variant) {
        const fieldsets = variantPicker.querySelectorAll('fieldset');
        
        for (let i = 0; i < fieldsets.length; i++) {
          const legend = fieldsets[i].querySelector('legend');
          if (legend) {
            const legendText = legend.textContent.toLowerCase().replace(':', '').trim();
            console.log(`VariantColorImages: Checking legend "${legendText}" against option "${optionName}"`);
            
            if (legendText.includes(optionName.toLowerCase())) {
              // Found the matching option, get the value from variant
              const optionProperty = `option${i + 1}`;
              const value = variant[optionProperty];
              console.log(`VariantColorImages: Found match at position ${i + 1}, value:`, value);
              return value;
            }
          }
        }
      }
      
      // Fallback: try to get from selected option values in the DOM
      const optionSelectors = document.querySelectorAll(
        `[name*="${optionName}" i], [data-option-name*="${optionName}" i]`
      );
      for (const selector of optionSelectors) {
        if (selector.checked || selector.selected) {
          const value = selector.value || selector.textContent?.trim();
          console.log(`VariantColorImages: Fallback found value:`, value);
          return value;
        }
      }
      
      console.log(`VariantColorImages: No value found for option "${optionName}"`);
      return null;
    }
    
    function resetImageVisibility() {
      console.log('VariantColorImages: Resetting image visibility');
      const mediaItems = getMediaItems();
      const thumbnailItems = getThumbnailItems();
      
      mediaItems.forEach(item => {
        // Reset all visibility and interaction properties
        item.style.display = '';
        item.style.visibility = '';
        item.style.opacity = '';
        item.style.pointerEvents = '';
        item.removeAttribute('hidden');
        item.removeAttribute('data-variant-filtered');
        item.removeAttribute('aria-hidden');
        
        // Restore click functionality to images inside
        const imgs = item.querySelectorAll('img');
        imgs.forEach(img => {
          img.style.pointerEvents = '';
          img.style.cursor = 'pointer';
        });
      });
      
      thumbnailItems.forEach(item => {
        // Reset all visibility and interaction properties
        item.style.display = '';
        item.style.visibility = '';
        item.style.opacity = '';
        item.style.pointerEvents = '';
        item.removeAttribute('hidden');
        item.removeAttribute('data-variant-filtered');
        item.removeAttribute('aria-hidden');
        
        // Restore click functionality to images inside
        const imgs = item.querySelectorAll('img');
        imgs.forEach(img => {
          img.style.pointerEvents = '';
          img.style.cursor = 'pointer';
        });
      });
      
      refreshCarousel();
    }
    
    function updateImageVisibility(optionValues) {
      console.log(`VariantColorImages: Updating image visibility with options:`, optionValues);
      
      // Get all media items
      const mediaItems = getMediaItems();
      const thumbnailItems = getThumbnailItems();
      // Resolve product title to align tag handling with Liquid filtering
      const productData = getProductData();
      const productTitleFromData = productData && productData.title;
      const productTitleElement = document.querySelector('.product-title');
      const productTitleFromDOM = productTitleElement && productTitleElement.textContent;
      
      const productTitle = productTitleFromData || productTitleFromDOM || '';
      const productTitleLower = productTitle.toLowerCase().trim();
      
      console.log('VariantColorImages: Product title detection:');
      console.log('  - From data:', productTitleFromData);
      console.log('  - From DOM:', productTitleFromDOM);
      console.log('  - Final title:', productTitle);
      console.log('  - Lowercase:', productTitleLower);
      
      if (mediaItems.length === 0) {
        console.log('VariantColorImages: No media items found');
        return;
      }
      
      // Store the currently selected image before filtering
      const currentlySelectedMedia = getCurrentlySelectedMedia();
      const currentlySelectedThumbnail = getCurrentlySelectedThumbnail();
      
      console.log('VariantColorImages: Currently selected media:', currentlySelectedMedia);
      console.log('VariantColorImages: Currently selected thumbnail:', currentlySelectedThumbnail);
      
      // If no options are selected, show all images
      if (!optionValues || Object.keys(optionValues).length === 0) {
        console.log('VariantColorImages: No options selected, showing all images');
        resetImageVisibility();
        return;
      }
      
      // Find images that match all selected options
      const matchingImages = [];
      const matchingThumbnails = [];
      // Track untagged items (no alt) which must always remain visible
      const untaggedMediaItems = [];
      const untaggedThumbnailItems = [];
      const optionKeys = Object.keys(optionValues);
      
      mediaItems.forEach((element, index) => {
        const img = element.querySelector('img');
        // If no image node, treat as untagged (do not filter)
        if (!img) {
          untaggedMediaItems.push(element);
          return;
        }
        
        const altText = (img.alt || '').toLowerCase().trim();
        // If no alt OR alt equals product title, treat as untagged (always show)
        if (!altText || altText === productTitleLower) {
          untaggedMediaItems.push(element);
          return;
        }
        let matches = true; // Start with true, require all options to match
        
        console.log(`VariantColorImages: Checking image with alt: "${altText}"`);
        
        // Check if the image matches all selected options
        for (const optionName of optionKeys) {
          const optionValue = optionValues[optionName];
          if (optionValue) {
            const valueLower = optionValue.toLowerCase();
            const hasExactMatch = altText === valueLower;
            const hasPartialMatch = altText.includes(valueLower) && altText !== '';
            
            if (!hasExactMatch && !hasPartialMatch) {
              matches = false;
              console.log(`VariantColorImages: Image "${altText}" does not match ${optionName}: "${optionValue}"`);
              break;
            } else {
              console.log(`VariantColorImages: Image "${altText}" matches ${optionName}: "${optionValue}"`);
            }
          }
        }
        
        // Only consider as matching if it's a real tagged alt (not product title)
        if (matches && altText !== productTitleLower) {
          matchingImages.push({element, index, altText});
        }
      });
      
      // Also check thumbnails
      thumbnailItems.forEach((element, index) => {
        const img = element.querySelector('img');
        // If no image node, treat as untagged (do not filter)
        if (!img) {
          untaggedThumbnailItems.push(element);
          return;
        }
        
        const altText = (img.alt || '').toLowerCase().trim();
        // If no alt OR alt equals product title, treat as untagged thumbnail
        if (!altText || altText === productTitleLower) {
          untaggedThumbnailItems.push(element);
          return;
        }
        let matches = true;
        
        console.log(`VariantColorImages: Checking thumbnail with alt: "${altText}"`);
        
        for (const optionName of optionKeys) {
          const optionValue = optionValues[optionName];
          if (optionValue) {
            const valueLower = optionValue.toLowerCase();
            const hasExactMatch = altText === valueLower;
            const hasPartialMatch = altText.includes(valueLower) && altText !== '';
            
            if (!hasExactMatch && !hasPartialMatch) {
              matches = false;
              break;
            }
          }
        }
        
        if (matches && altText !== productTitleLower) {
          matchingThumbnails.push({element, index, altText});
        }
      });
      
      console.log(`VariantColorImages: Found ${matchingImages.length} matching images and ${matchingThumbnails.length} matching thumbnails for options:`, optionValues);
      console.log(`VariantColorImages: Untagged media count: ${untaggedMediaItems.length}, untagged thumbnails count: ${untaggedThumbnailItems.length}`);
      
      // If no matching images, show all images and thumbnails
      if (matchingImages.length === 0 && matchingThumbnails.length === 0) {
        console.log('VariantColorImages: No matching images found, showing all');
        mediaItems.forEach(item => {
          // Show the item
          item.style.display = '';
          item.style.visibility = '';
          item.style.opacity = '';
          item.removeAttribute('hidden');
          item.removeAttribute('data-variant-filtered');
        });
        thumbnailItems.forEach(item => {
          // Show the thumbnail
          item.style.display = '';
          item.style.visibility = '';
          item.style.opacity = '';
          item.removeAttribute('hidden');
          item.removeAttribute('data-variant-filtered');
        });
      } else {
        // Hide all images and thumbnails first, then show only matching ones
        const visibleMediaItems = [];
        const visibleThumbnailItems = [];
        
        mediaItems.forEach(item => {
          const img = item.querySelector('img');
          if (!img) {
            // No image, keep visible
            visibleMediaItems.push(item);
            return;
          }
          
          const altText = (img.alt || '').toLowerCase().trim();
          console.log(`VariantColorImages: Media alt comparison - Alt: "${altText}" vs Product: "${productTitleLower}" (Match: ${altText === productTitleLower})`);
          
          if (!altText || altText === productTitleLower) {
            // Empty alt text OR alt equals product title - keep visible (don't hide during filtering)
            visibleMediaItems.push(item);
            console.log(`VariantColorImages: Keeping untagged media visible (alt: "${altText}")`);
            return;
          }
          
          // Hide images with alt text for filtering
          item.style.display = 'none';
          item.style.visibility = 'hidden';
          item.style.opacity = '0';
          item.style.pointerEvents = 'none';
          item.setAttribute('hidden', 'true');
          item.setAttribute('data-variant-filtered', 'true');
          item.setAttribute('aria-hidden', 'true');
          
          // Also hide any images inside
          const imgs = item.querySelectorAll('img');
          imgs.forEach(imgEl => {
            imgEl.style.pointerEvents = 'none';
            imgEl.style.cursor = 'default';
          });
        });
        
        thumbnailItems.forEach(item => {
          const img = item.querySelector('img');
          if (!img) {
            // No image, keep visible
            visibleThumbnailItems.push(item);
            return;
          }
          
          const altText = (img.alt || '').toLowerCase().trim();
          console.log(`VariantColorImages: Thumbnail alt comparison - Alt: "${altText}" vs Product: "${productTitleLower}" (Match: ${altText === productTitleLower})`);
          
          if (!altText || altText === productTitleLower) {
            // Empty alt text OR alt equals product title - keep visible (don't hide during filtering)
            visibleThumbnailItems.push(item);
            console.log(`VariantColorImages: Keeping untagged thumbnail visible (alt: "${altText}")`);
            return;
          }
          
          // Hide thumbnails with alt text for filtering
          item.style.display = 'none';
          item.style.visibility = 'hidden';
          item.style.opacity = '0';
          item.style.pointerEvents = 'none';
          item.setAttribute('hidden', 'true');
          item.setAttribute('data-variant-filtered', 'true');
          item.setAttribute('aria-hidden', 'true');

          // Also hide any images inside
          const imgs = item.querySelectorAll('img');
          imgs.forEach(imgEl => {
            imgEl.style.pointerEvents = 'none';
            imgEl.style.cursor = 'default';
          });
        });
        
        // Show only matching images
        matchingImages.forEach(({element, index, altText}) => {
          // Show the item and restore full functionality
          element.style.display = '';
          element.style.visibility = '';
          element.style.opacity = '';
          element.style.pointerEvents = '';
          element.removeAttribute('hidden');
          element.removeAttribute('data-variant-filtered');
          element.removeAttribute('aria-hidden');
          
          // Restore click functionality to images inside
          const imgs = element.querySelectorAll('img');
          imgs.forEach(img => {
            img.style.pointerEvents = '';
            img.style.cursor = 'pointer';
          });
          
          visibleMediaItems.push(element);
          console.log(`VariantColorImages: Showing image ${index} (${altText})`);
        });

        // Show only matching thumbnails
        matchingThumbnails.forEach(({element, index, altText}) => {
          // Show the thumbnail and restore full functionality
          element.style.display = '';
          element.style.visibility = '';
          element.style.opacity = '';
          element.style.pointerEvents = '';
          element.removeAttribute('hidden');
          element.removeAttribute('data-variant-filtered');
          element.removeAttribute('aria-hidden');
          
          // Restore click functionality to images inside
          const imgs = element.querySelectorAll('img');
          imgs.forEach(img => {
            img.style.pointerEvents = '';
            img.style.cursor = 'pointer';
          });
          
          visibleThumbnailItems.push(element);
          console.log(`VariantColorImages: Showing thumbnail ${index} (${altText})`);
        });
        
        // Handle image selection after filtering
        handleImageSelectionAfterFiltering(
          currentlySelectedMedia, 
          currentlySelectedThumbnail, 
          visibleMediaItems, 
          visibleThumbnailItems,
          matchingImages,
          matchingThumbnails
        );
      }
      
      // Force browser to reflow and refresh carousel
      setTimeout(() => {
        // Trigger multiple events to ensure proper refresh
        window.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('load'));
        
        // Refresh carousel and re-initialize any click handlers
        refreshCarousel();

        // Re-apply a pending selection after refresh to avoid race conditions
        if (pendingSelection && pendingSelection.media) {
          console.log('VariantColorImages: Applying pending selection after refresh');
          setSelectedMedia(pendingSelection.media, pendingSelection.thumbnail || null);
          pendingSelection = null;
        }
        
        // Re-initialize any image click handlers that might have been lost
        const visibleImages = productGallery.querySelectorAll('.product-gallery__media:not([hidden]) img');
        visibleImages.forEach(img => {
          // Ensure images are clickable
          img.style.pointerEvents = '';
          img.style.cursor = 'pointer';
        });
        
        console.log(`VariantColorImages: Refreshed carousel with ${visibleImages.length} visible images`);
      }, 100);
    }
    
    function handleImageSelectionAfterFiltering(
      currentlySelectedMedia, 
      currentlySelectedThumbnail, 
      visibleMediaItems, 
      visibleThumbnailItems,
      matchingImages,
      matchingThumbnails
    ) {
      console.log('VariantColorImages: Handling image selection after filtering');
      
      // Prefer selecting the first matching image for the chosen variant.
      // This avoids odd cases where carousels end up at the last image.
      const hasMatching = Array.isArray(matchingImages) && matchingImages.length > 0;
      const firstMatchingMedia = hasMatching ? matchingImages[0]?.element : null;
      const firstMatchingThumbnail = (Array.isArray(matchingThumbnails) && matchingThumbnails.length > 0)
        ? matchingThumbnails[0]?.element
        : null;

      // Check if the currently selected media is still visible
      const isCurrentMediaVisible = currentlySelectedMedia && visibleMediaItems.includes(currentlySelectedMedia);
      const isCurrentThumbnailVisible = currentlySelectedThumbnail && visibleThumbnailItems.includes(currentlySelectedThumbnail);

      console.log('VariantColorImages: Current media visible:', isCurrentMediaVisible);
      console.log('VariantColorImages: Current thumbnail visible:', isCurrentThumbnailVisible);

      if (hasMatching) {
        // Always select the first matching image on variant change
        console.log('VariantColorImages: Selecting first matching image for variant');
        setSelectedMedia(firstMatchingMedia, firstMatchingThumbnail);
        // Also set as pending so it is re-applied post-refresh if needed
        pendingSelection = { media: firstMatchingMedia, thumbnail: firstMatchingThumbnail };
        return;
      }

      // Fallback: If no matching images, ensure at least the first visible is selected
      if (!isCurrentMediaVisible && visibleMediaItems.length > 0) {
        const firstVisibleMedia = visibleMediaItems[0];
        const firstVisibleThumbnail = visibleThumbnailItems.length > 0 ? visibleThumbnailItems[0] : null;
        console.log('VariantColorImages: Selecting first visible image (fallback):', firstVisibleMedia);
        setSelectedMedia(firstVisibleMedia, firstVisibleThumbnail);
      }
    }
    
    function getMediaItems() {
      // Try different selectors to find media items
      let items = productGallery.querySelectorAll('.product-gallery__media');
      if (items.length === 0) {
        items = productGallery.querySelectorAll('.product-gallery__media-wrapper');
      }
      if (items.length === 0) {
        items = productGallery.querySelectorAll('[data-media-id]');
      }
      if (items.length === 0) {
        // Try to find any direct children that might contain images
        const children = Array.from(productGallery.children).filter(child => {
          return !['SCRIPT', 'STYLE'].includes(child.tagName) && 
                 child.querySelector('img');
        });
        items = children;
      }
      
      // Store original display states on first run
      if (originalStates.size === 0) {
        Array.from(items).forEach((item, index) => {
          originalStates.set(index, {
            display: item.style.display,
            hidden: item.hidden,
            visibility: item.style.visibility
          });
        });
      }
      
      return Array.from(items);
    }
    
    function getThumbnailItems() {
      // Try different selectors to find thumbnail items
      let items = productGallery.querySelectorAll('.product-gallery__thumbnail');
      if (items.length === 0) {
        items = productGallery.querySelectorAll('.product-gallery__thumbnail-wrapper');
      }
      if (items.length === 0) {
        items = productGallery.querySelectorAll('[data-thumbnail-id]');
      }
      
      return Array.from(items);
    }
    
    function getCurrentlySelectedMedia() {
      const mediaItems = getMediaItems();
      return mediaItems.find(item => item.getAttribute('aria-current') === 'true') || null;
    }
    
    function getCurrentlySelectedThumbnail() {
      const thumbnailItems = getThumbnailItems();
      return thumbnailItems.find(item => item.getAttribute('aria-current') === 'true') || null;
    }
    
    function getMediaPosition(element) {
      return element.getAttribute('data-media-position') || element.getAttribute('data-position');
    }
    
    function setSelectedMedia(mediaElement, thumbnailElement) {
      console.log('VariantColorImages: Setting selected media:', mediaElement, thumbnailElement);
      
      // Clear all current selections
      const allMediaItems = getMediaItems();
      const allThumbnailItems = getThumbnailItems();
      
      allMediaItems.forEach(item => item.setAttribute('aria-current', 'false'));
      allThumbnailItems.forEach(item => item.setAttribute('aria-current', 'false'));
      
      // Set new selections
      if (mediaElement) {
        mediaElement.setAttribute('aria-current', 'true');
      }
      if (thumbnailElement) {
        thumbnailElement.setAttribute('aria-current', 'true');
      }
      
      // Trigger the gallery to update its view
      const gallery = document.querySelector('product-gallery');
      if (gallery && mediaElement) {
        const mediaPosition = getMediaPosition(mediaElement);
        if (mediaPosition) {
          // Find the index of this media item among visible items
          const visibleMediaItems = allMediaItems.filter(item => !item.hasAttribute('hidden') && item.style.display !== 'none');
          const mediaIndex = visibleMediaItems.indexOf(mediaElement);
          
          if (mediaIndex >= 0) {
            console.log(`VariantColorImages: Selecting media at index ${mediaIndex} (position ${mediaPosition})`);
            
            // Try to trigger the gallery's select method if available
            if (gallery.select && typeof gallery.select === 'function') {
              gallery.select(mediaIndex);
            }
          }
        }
      }
    }
    
    function analyzeImages(mediaItems, selectedValue) {
      const items = [];
      let hasMatches = false;
      
      // First pass: check if any images match the selected value
      mediaItems.forEach((element) => {
        const img = element.querySelector('img');
        if (!img) return;
        
        const altText = (img.alt || '').toLowerCase().trim();
        const isExactMatch = altText === selectedValue;
        const isPartialMatch = altText.includes(selectedValue) && altText !== '';
        
        if (isExactMatch || isPartialMatch) {
          hasMatches = true;
        }
      });
      
      // Second pass: determine which images to show
      mediaItems.forEach((element, index) => {
        const img = element.querySelector('img');
        if (!img) return;
        
        const altText = (img.alt || '').toLowerCase().trim();
        const isExactMatch = altText === selectedValue;
        const isPartialMatch = altText.includes(selectedValue) && altText !== '';
        const isMatch = isExactMatch || isPartialMatch;
        
        // If no images match the selected value, show all images
        // Otherwise, only show images that match the selected value
        const shouldShow = !hasMatches || isMatch;
        
        items.push({
          element: element,
          altText: altText,
          isMatch: isMatch,
          shouldShow: shouldShow,
          index: index
        });
      });
      
      return {
        items: items,
        hasMatches: hasMatches
      };
    }
    
    function refreshCarousel() {
      console.log('VariantColorImages: Refreshing carousel');
      
      // Try to refresh different types of carousels
      const carousel = productGallery.querySelector('scroll-carousel');
      const swiperCarousel = productGallery.querySelector('.swiper');
      const flickityCarousel = productGallery.querySelector('.flickity-enabled');
      
      if (carousel) {
        console.log('VariantColorImages: Found scroll-carousel');
        setTimeout(() => {
          if (typeof carousel.refresh === 'function') {
            carousel.refresh();
          }
          if (typeof carousel.update === 'function') {
            carousel.update();
          }
          // Force recalculation
          carousel.style.display = 'none';
          carousel.offsetHeight; // Trigger reflow
          carousel.style.display = '';
        }, 50);
      }
      
      if (swiperCarousel) {
        console.log('VariantColorImages: Found swiper carousel');
        // Try to update swiper if it exists
        if (window.Swiper && swiperCarousel.swiper) {
          swiperCarousel.swiper.update();
        }
      }
      
      if (flickityCarousel) {
        console.log('VariantColorImages: Found flickity carousel');
        // Try to update flickity if it exists
        if (window.Flickity) {
          const flickity = window.Flickity.data(flickityCarousel);
          if (flickity) {
            flickity.resize();
          }
        }
      }
      
      // General carousel refresh
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
    }
  }
  
  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantColorImages);
  } else {
    initVariantColorImages();
  }
  
  // Also initialize on load
  window.addEventListener('load', initVariantColorImages);
  
  // And initialize after a short delay
  setTimeout(initVariantColorImages, 500);
})();